var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBurger = function SvgMenuBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2 6.5C2 5.672 2.64 5 3.429 5H20.57C21.361 5 22 5.672 22 6.5S21.36 8 20.571 8H3.43C2.639 8 2 7.328 2 6.5m0 6c0-.828.64-1.5 1.429-1.5H20.57c.79 0 1.429.672 1.429 1.5s-.64 1.5-1.429 1.5H3.43C2.639 14 2 13.328 2 12.5m0 6c0-.828.64-1.5 1.429-1.5H20.57c.79 0 1.429.672 1.429 1.5s-.64 1.5-1.429 1.5H3.43C2.639 20 2 19.328 2 18.5",
    clipRule: "evenodd"
  })));
};
export default SvgMenuBurger;